var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.document)?_c('div',[_c('rich-text-renderer',{attrs:{"role":"presentation","document":_vm.document,"nodeRenderers":_vm.renderNode}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }